<template>
  <div>
    <header :class="showBg ? 'top-header' : 'top-header top-header-bg'">
      <div class="container2 top-header-container">
        <el-row>
          <div class="fx header-col">
            <el-col :span="7">
              <div class="logo fx" @click="$router.push('/')"><span>教学资源库</span> <span>{{ schoolInfo.fullName }}</span>
              </div>

            </el-col>
            <el-col :span="14" :offset="3" style="text-align: right;">
              <div class="top-right">
                <!-- <template v-if="showBg"> -->
                <span :class="a_index == index ? 'active' : ''" class="top-nav-item" v-for="(item, index) in navList"
                  :key="index" @click="navClick(item, index)">{{ item.title }}</span>
                <el-dropdown v-if="token">
                  <span class="el-dropdown-link">
                    {{ personInfo.studentName }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="$router.push('/personCenter')">个人中心</el-dropdown-item>
                    <!-- <el-dropdown-item @click.native="$router.push('/collectList')">我的收藏</el-dropdown-item> -->
                    <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>

                  </el-dropdown-menu>
                </el-dropdown>
                <span class="top-nav-item" v-else @click="$router.push('/login')">学生登录</span>
              </div>
            </el-col>
          </div>
        </el-row>
      </div>
    </header>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import mixin from '@/utils/mixin';
import { logout } from "@/utils/api"
export default {
  mixins: [mixin],
  props: {
    showBg: {
      default: true
    },
    showLogo: {
      default: false
    }
  },

  computed: mapGetters(['schoolInfo', 'token', 'navList', 'personInfo', 'a_index']),

  methods: {
    logout() {
      if (this.$route.path === '/resourceDetail') {
        this.$emit('logout')
      } else {
        logout({ id: this.token,organizeId:this.$config.schoolId }).then(res => {
          if (res.code == 200) {
            this.$message.success('退出成功')
            this.$store.commit('set_token', '')
            this.$store.commit('set_user_info', {})
            if (this.$route.path === '/personCenter') {
              this.$router.push('/')
            }
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.top-bg {
  width: 100%;
  height: 58px;
  background: url('../assets/images/bj.jpg') no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -2;
}

.el-dropdown {
  color: #fff;
}

.top-header {
  width: 100%;
  height: 58px;
  background: linear-gradient(to left, #3191f8, #1a79e5, #015cce);
  /* border-bottom: 1px solid #4f8ef5; */
}

.active {
  font-weight: bold;
}

.top-header-bg {
  /* background: #1B66E6; */
  background: linear-gradient(to left, #3191f8, #1a79e5, #015cce);
}

.top-header-container {
  height: 58px;
}

.logo {
  /* font-weight: bold; */
  /* font-size: 20px; */
  font-size: 16px;
  color: #fff;
  user-select: none;
  cursor: pointer;
}

.logo span:first-child {
  font-size: 22px;
  font-weight: bold;
  padding-right: 10px;
  position: relative;
}

.logo span:first-child::after {
  content: '';
  width: 1px;
  height: 18px;
  background: #ccc;
  position: absolute;
  top: 12px;
  right: 0;
}

.logo span:last-child {
  padding-left: 10px;
}

.logo img {
  width: 187px;
}

.header-col {
  height: 58px;
}

.head-search {
  width: 180px;
  margin-right: 10px;
}

.top-right span {
  cursor: pointer;
  user-select: none;
}

.top-nav-item {
  color: #fff;
  margin-right: 15px;
  font-size: 15px;
  display: inline-block;
}
</style>